import { createContext, PropsWithChildren, useReducer } from 'react';

import { logger } from '~/utils/logger';

const AlertContext = createContext([{}, () => {}]);
AlertContext.displayName = 'AlertContext';

const initialState = {
  alerts: [],
};

const reducer = (state, action) => {
  let newAlerts, element;
  switch (action.type) {
    case 'ADD_ALERT':
      newAlerts = [...state.alerts, action.payload];
      return { ...state, alerts: newAlerts };
    case 'REMOVE_ALERT':
      element = state.alerts.filter((e) => e.id !== action.payload.id);
      return { alerts: element };
    default:
      logger.error('No valid action: ' + action.type);
      return state;
  }
};

type AlertContextProviderProps = PropsWithChildren;
function AlertContextProvider({ children }: AlertContextProviderProps) {
  const [state, dispatch] = useReducer(reducer, initialState);

  const actions = {
    addAlert: (payload) => {
      dispatch({ type: 'ADD_ALERT', payload });
    },
    removeAlert: (payload) => {
      dispatch({ type: 'REMOVE_ALERT', payload });
    },
  };

  return <AlertContext.Provider value={{ state, actions }}>{children}</AlertContext.Provider>;
}

export { AlertContext, AlertContextProvider };
